import { render, staticRenderFns } from "./AdminAnimation.vue?vue&type=template&id=c2534648&scoped=true&"
import script from "./AdminAnimation.vue?vue&type=script&lang=js&"
export * from "./AdminAnimation.vue?vue&type=script&lang=js&"
import style0 from "./AdminAnimation.vue?vue&type=style&index=0&id=c2534648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2534648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VForm,VTab,VTabItem,VTabs,VTextField,VTextarea})
